import { LinksValue } from "@/web-client/api";
import { FC } from "react";

type ContactableReponseType = { links?: LinksValue; contact_email?: string };

interface Props {
  contactableResponese: ContactableReponseType;
  clickHandler(linkType: string): void;
}

const SocialLinks: FC<Props> = ({
  contactableResponese: { links, contact_email },
  clickHandler,
}) => {
  // どちらもなければレンダリングしない
  if (!links && !contact_email) return null;

  return (
    <ul className="text-lg flex gap-24">
      {links?.homepage && (
        <li>
          <a
            href={links.homepage}
            onClick={() => clickHandler("homepage")}
            rel="noopener noreferrer"
            target="_blank"
            className="hover:no-underline"
          >
            <i className="icon-Home"></i>
          </a>
        </li>
      )}
      {contact_email && (
        <li>
          <a
            href={`mailto:${contact_email}`}
            onClick={() => clickHandler("email")}
            className="hover:no-underline"
          >
            <i className="icon-Mail"></i>
          </a>
        </li>
      )}
      {links?.instagram && (
        <li>
          <a
            href={`${links.instagram}`}
            onClick={() => clickHandler("instagram")}
            rel="noopener noreferrer"
            target="_blank"
            className="hover:no-underline"
          >
            <i className="icon-Instagram"></i>
          </a>
        </li>
      )}
      {links?.twitter && (
        <li>
          <a
            href={`${links.twitter}`}
            onClick={() => clickHandler("twitter")}
            rel="noopener noreferrer"
            target="_blank"
            className="hover:no-underline"
          >
            <i className="icon-Twitter"></i>
          </a>
        </li>
      )}
      {links?.facebook && (
        <li>
          <a
            href={`${links.facebook}`}
            onClick={() => clickHandler("facebook")}
            rel="noopener noreferrer"
            target="_blank"
            className="hover:no-underline"
          >
            <i className="icon-Facebook"></i>
          </a>
        </li>
      )}
    </ul>
  );
};
export default SocialLinks;
